// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__32wD5","addWidgetButton":"Header_addWidgetButton__OBvnn","dashboardTabs":"Header_dashboardTabs__3X_SH","active":"Header_active__2XmDc"};